import React, { Component, Fragment } from 'react'
import Breadcrumb from '../common/breadcrumb';
import Swal from "sweetalert2";
import { Select, Upload } from "antd";
import ImgCrop from "antd-img-crop";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { clear_auth, set_auth } from "../../reducers/Auth";
import UploadIcon from '../../assets/icons/import-icon-blue-light.svg'

export class Add_karyawan extends Component {
    constructor(props) {
        super(props);
        this.state = {
            prosesSimpan: false,
            isLoading: true,
            divisi: [],
            jabatan: [],
            lokasi: [],
            fileList: [],
            fileKtp: [],
            fileSelfie: [],
            fileIjazah: [],
            perusahaan_karyawan: '',
            foto_karyawan: '',
            foto_ktp: '',
            foto_selfie: '',
            foto_ijazah: '',
            nama_karyawan: '',
            no_induk_karyawan: '',
            gender_karyawan: 'Laki-laki',
            divisi_karyawan: '',
            jabatan_karyawan: '',
            lokasi_karyawan: null,
            email_karyawan: '',
            ttl_karyawan: '',
            join_date_karyawan: '',
            no_hp_karyawan: '',
            alamat_karyawan: '',
            no_npwp: '',
            no_bpjs: '',
        }
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        })
    }

    loadJabatan() {
        let form = {}
        this.props.request("get_jabatan_perusahaan", form, 'POST')
            .then(response => {
                if (response.success) {
                    this.setState({
                        isLoading: false,
                        jabatan: response.data
                    })
                }
            });
    }

    loadDivisi() {
        let form = {}
        this.props.request("get_divisi_perusahaan", form, 'POST')
            .then(response => {
                if (response.success) {
                    this.setState({
                        isLoading: false,
                        divisi: response.data
                    })
                }
            });
    }

    loadLokasi() {
        let form = {}
        this.props.request("get_lokasi_perusahaan", form, 'POST')
            .then(response => {
                if (response.success) {
                    this.setState({
                        lokasi: response.data,
                        lokasi_karyawan: null,
                    })
                }
            });
    }

    lokasiHandler = () => {
        if (this.state.lokasi_karyawan === null) {
            this.setState({
                lokasi_karyawan: ''
            })
        } else {
            this.setState({
                lokasi_karyawan: null
            })
        }
    }

    simpanKaryawan = () => {
        this.setState({
            prosesSimpan: true,
        })

        let form = {
            lokasi_karyawan: this.state.lokasi_karyawan,
            foto_karyawan: this.state.foto_karyawan,
            foto_selfie: this.state.foto_selfie,
            foto_ijazah: this.state.foto_ijazah,
            foto_ktp: this.state.foto_ktp,
            nama_karyawan: this.state.nama_karyawan,
            no_induk_karyawan: this.state.no_induk_karyawan,
            gender_karyawan: this.state.gender_karyawan,
            email_karyawan: this.state.email_karyawan,
            jabatan_karyawan: this.state.jabatan_karyawan,
            divisi_karyawan: this.state.divisi_karyawan,
            ttl_karyawan: this.state.ttl_karyawan,
            join_date_karyawan: this.state.join_date_karyawan,
            no_hp_karyawan: this.state.no_hp_karyawan,
            alamat_karyawan: this.state.alamat_karyawan,
            no_npwp: this.state.no_npwp,
            no_bpjs: this.state.no_bpjs,
        }

        this.props.request("karyawan/add_karyawan", form, 'POST')
            .then(response => {
                if (response.success) {
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.success,
                        icon: 'success'
                    })
                    this.props.history.push('/karyawan/list-karyawan/0')
                } else {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.failed,
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                }
                this.setState({
                    prosesSimpan: false,
                })
            });
    }

    cekMasterData() {
        if (this.props.user.perusahaan.divisi === null || this.props.user.perusahaan.jabatan.length < 1 || this.props.user.perusahaan.lokasi.length < 1) {
            Swal.fire({
                title: 'Peringatan!',
                text: 'Anda harus menambahkan Seluruh Master Data terlebih dahulu',
                icon: 'warning',
            })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.props.history.push('/karyawan/shift')
                    }
                })
        }
    }

    componentDidMount() {
        this.cekMasterData()
        this.loadLokasi()
        this.loadDivisi()
        this.loadJabatan()
    }

    render() {
        const { Option } = Select;
        const {divisi, jabatan} = this.state
        return (
            <Fragment>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Tambah Karyawan - Presensi</title>
                    <meta name="description" content="Detail Absensi" />
                </Helmet>
                <Breadcrumb title="Tambah Karyawan" parent="Karyawan" />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-body">
                                    <form className="needs-validation user-add" noValidate="">
                                        <div className='row mb-2'>
                                            <div className='col-md-6'>
                                                <h4>Detail Karyawan</h4>
                                            </div>
                                            <div className='col-md-6 d-flex justify-content-end'>
                                                <a className='btn btn-outline-secondary mr-2 text-capitalize' href="list-karyawan/0">Batalkan</a>
                                                {this.state.prosesSimpan === false ?
                                                    <button type="button" className="btn btn-primary text-capitalize"
                                                            onClick={this.simpanKaryawan}><i className="fa fa-floppy-o"></i> Simpan</button>
                                                    :
                                                    <button type="button" className="btn btn-primary text-capitalize"><i className="fa fa-refresh fa-spin"></i> Loading</button>
                                                }
                                            </div>
                                        </div>
                                        <div className="form-group row col-md-12">
                                            <div className="col-lg-3 col-md-6">
                                                <ImgCrop
                                                    rotate
                                                    width={750}
                                                    height={1000}>
                                                    <Upload customRequest={({ file, onSuccess }) => {
                                                        setTimeout(() => {
                                                            onSuccess("ok");
                                                        }, 0);
                                                    }}
                                                        listType="picture-card"
                                                        fileList={this.state.fileList}
                                                        className="antd-upload-custom"
                                                        onRemove={() => {
                                                            this.setState({ foto_karyawan: null })
                                                        }}
                                                        onChange={(file) => {
                                                            this.setState({ fileList: file.fileList })

                                                            if (file.fileList.length > 0) {
                                                                let files = file.file.originFileObj
                                                                let reader = new FileReader()

                                                                reader.readAsDataURL(files)
                                                                reader.onloadend = () => {
                                                                    this.setState({
                                                                        foto_karyawan: {
                                                                            name: file.file.name,
                                                                            file: reader.result
                                                                        }
                                                                    })
                                                                }
                                                            }
                                                            else {
                                                                this.setState({ foto_karyawan: [] })
                                                            }
                                                        }}
                                                    >
                                                        {this.state.fileList.length >= 1 ? null :
                                                            <div className="p-2 d-flex align-items-center justify-content-center flex-column" style={{height: "167px"}}>
                                                                <span>
                                                                    <img src={UploadIcon} style={{height: "24px", width: "24px"}} />
                                                                </span>
                                                                <p className="ant-upload-text mb-3" style={{fontSize: "12px", fontWeight: 400, lineHeight: "16px", marginTop: "6px"}}>Upload foto karyawan</p>
                                                                <a className="btn btn-outline-custom tambah-karyawan">Cari Gambar</a>
                                                            </div>
                                                        }
                                                    </Upload>
                                                </ImgCrop>
                                            </div>
                                            <div className="col-lg-3 col-md-6">
                                                <ImgCrop
                                                    rotate
                                                    width={550}
                                                    height={860}>
                                                    <Upload customRequest={({ file, onSuccess }) => {
                                                        setTimeout(() => {
                                                            onSuccess("ok");
                                                        }, 0);
                                                    }}
                                                        listType="picture-card"
                                                        fileList={this.state.fileSelfie}
                                                        className="antd-upload-custom"
                                                        onRemove={() => {
                                                            this.setState({ foto_selfie: null })
                                                        }}
                                                        onChange={(file) => {
                                                            this.setState({ fileSelfie: file.fileList })

                                                            if (file.fileList.length > 0) {
                                                                let files = file.file.originFileObj
                                                                let reader = new FileReader()

                                                                reader.readAsDataURL(files)
                                                                reader.onloadend = () => {
                                                                    this.setState({
                                                                        foto_selfie: {
                                                                            name: file.file.name,
                                                                            file: reader.result
                                                                        }
                                                                    })
                                                                }
                                                            }
                                                            else {
                                                                this.setState({ foto_selfie: [] })
                                                            }
                                                        }}
                                                    >
                                                        {this.state.fileSelfie.length >= 1 ? null :
                                                            <div className="p-2 d-flex flex-column align-items-center justify-content-center" style={{height: "167px"}}>
                                                                <span>
                                                                    <img src={UploadIcon} style={{height: "24px", width: "24px"}} />
                                                                </span>
                                                                <p className="ant-upload-text mb-3" style={{fontSize: "12px", fontWeight: 400, lineHeight: "16px", marginTop: "6px"}}>Upload foto selfie karyawan</p>
                                                                <a className="btn btn-outline-custom tambah-karyawan">Cari Gambar</a>
                                                            </div>
                                                        }
                                                    </Upload>
                                                </ImgCrop>
                                            </div>
                                            <div className="col-lg-3 col-md-6">
                                                <ImgCrop
                                                    rotate
                                                    width={960}
                                                    height={480}>
                                                    <Upload customRequest={({ file, onSuccess }) => {
                                                        setTimeout(() => {
                                                            onSuccess("ok");
                                                        }, 0);
                                                    }}
                                                        listType="picture-card"
                                                        fileList={this.state.fileKtp}
                                                        className="antd-upload-custom"
                                                        onRemove={() => {
                                                            this.setState({ foto_ktp: null })
                                                        }}
                                                        onChange={(file) => {
                                                            this.setState({ fileKtp: file.fileList })

                                                            if (file.fileList.length > 0) {
                                                                let files = file.file.originFileObj
                                                                let reader = new FileReader()

                                                                reader.readAsDataURL(files)
                                                                reader.onloadend = () => {
                                                                    this.setState({
                                                                        foto_ktp: {
                                                                            name: file.file.name,
                                                                            file: reader.result
                                                                        }
                                                                    })
                                                                }
                                                            }
                                                            else {
                                                                this.setState({ foto_ktp: [] })
                                                            }
                                                        }}
                                                    >
                                                        {this.state.fileKtp.length >= 1 ? null :
                                                            <div className="p-2 d-flex flex-column align-items-center justify-content-center" style={{height: "167px"}}>
                                                                <span>
                                                                    <img src={UploadIcon} style={{height: "24px", width: "24px"}} />
                                                                </span>
                                                                <p className="ant-upload-text mb-3" style={{fontSize: "12px", fontWeight: 400, lineHeight: "16px", marginTop: "6px"}}>Upload foto KTP karyawan</p>
                                                                <a className="btn btn-outline-custom tambah-karyawan">Cari Gambar</a>
                                                            </div>
                                                        }
                                                    </Upload>
                                                </ImgCrop>
                                            </div>
                                            <div className="col-lg-3 col-md-6">
                                                <ImgCrop
                                                    rotate
                                                    width={550}
                                                    height={860}>
                                                    <Upload customRequest={({ file, onSuccess }) => {
                                                        setTimeout(() => {
                                                            onSuccess("ok");
                                                        }, 0);
                                                    }}
                                                        listType="picture-card"
                                                        fileList={this.state.fileIjazah}
                                                        className="antd-upload-custom"
                                                        onRemove={() => {
                                                            this.setState({ foto_ijazah: null })
                                                        }}
                                                        onChange={(file) => {
                                                            this.setState({ fileIjazah: file.fileList })

                                                            if (file.fileList.length > 0) {
                                                                let files = file.file.originFileObj
                                                                let reader = new FileReader()

                                                                reader.readAsDataURL(files)
                                                                reader.onloadend = () => {
                                                                    this.setState({
                                                                        foto_ijazah: {
                                                                            name: file.file.name,
                                                                            file: reader.result
                                                                        }
                                                                    })
                                                                }
                                                            }
                                                            else {
                                                                this.setState({ foto_ijazah: [] })
                                                            }
                                                        }}
                                                    >
                                                        {this.state.fileIjazah.length >= 1 ? null :
                                                            <div className="p-2 d-flex align-items-center justify-content-center flex-column" style={{height: "167px"}}>
                                                                <span>
                                                                    <img src={UploadIcon} style={{height: "24px", width: "24px"}} />
                                                                </span>
                                                                <p className="ant-upload-text mb-3" style={{fontSize: "12px", fontWeight: 400, lineHeight: "16px", marginTop: "6px"}}>Upload foto ijazah dan sertifikat</p>
                                                                <a className="btn btn-outline-custom tambah-karyawan">Cari Gambar</a>
                                                            </div>
                                                        }
                                                    </Upload>
                                                </ImgCrop>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label style={{ fontSize: "12px", color: "#143B5E" }} className="mb-2 font-weight-bold">Nama Karyawan</label>
                                                    <div>
                                                        <input style={{ fontSize: "12px" }} name="nama_karyawan" className="form-control" placeholder="Nama Karyawan..."
                                                            type="text" required="" onChange={this.handleChange} />
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label style={{ fontSize: "12px", color: "#143B5E" }} className="mb-2 font-weight-bold">Nomor Induk Karyawan (Opsional)</label>
                                                    <div>
                                                        <input style={{ fontSize: "12px" }} name="no_induk_karyawan" className="form-control" placeholder="Nomor Induk Karyawan..."
                                                               type="text" required="" onChange={this.handleChange} />
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label style={{ fontSize: "12px", color: "#143B5E" }} className="mb-2 font-weight-bold">Email</label>
                                                    <div>
                                                        <input style={{ fontSize: "12px" }} name="email_karyawan" className="form-control" placeholder="Email Karyawan..."
                                                            type="email" required="" onChange={this.handleChange} />
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label style={{ fontSize: "12px", color: "#143B5E" }}className="mb-2 font-weight-bold">No. Handphone</label>
                                                    <div>
                                                        <input style={{ fontSize: "12px" }} name="no_hp_karyawan" className="form-control"
                                                            type="number" required="" placeholder="No. HP Karyawan..." onChange={this.handleChange} />
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label style={{ fontSize: "12px", color: "#143B5E" }}className="mb-2 font-weight-bold">Alamat</label>
                                                    <div>
                                                        <textarea style={{ fontSize: "12px" }} name="alamat_karyawan" type="text" className="form-control" placeholder="Alamat Karyawan..." onChange={this.handleChange}></textarea>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label style={{ fontSize: "12px", color: "#143B5E" }}className="mb-2 font-weight-bold">Nomor Pokok Wajib Pajak (Opsional)</label>
                                                    <div>
                                                        <input maxLength={16} style={{ fontSize: "12px" }} name="no_npwp" type="text" className="form-control" placeholder="Nomor Pokok Wajib Pajak..." onChange={this.handleChange} />
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label style={{ fontSize: "12px", color: "#143B5E" }}className="mb-2 font-weight-bold">No. BPJS (Opsional)</label>
                                                    <div>
                                                        <input maxLength={16} style={{ fontSize: "12px" }} name="no_bpjs" type="text" className="form-control" placeholder="No. BPJS..." onChange={this.handleChange} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="row">
                                                    <div className="col-6">
                                                        <div className="form-group">
                                                            <label style={{ fontSize: "12px", color: "#143B5E" }}className="mb-2 font-weight-bold">Tanggal Lahir</label>
                                                            <div>
                                                                <input style={{ fontSize: "12px" }} name="ttl_karyawan" className="form-control" onChange={this.handleChange}
                                                                    type="date" required="" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="form-group">
                                                            <label style={{ fontSize: "12px", color: "#143B5E" }}className="mb-2 font-weight-bold">Jenis Kelamin Karyawan</label>
                                                            <div>
                                                                <div class="form-check form-check-inline">
                                                                    <input class="form-check-input" type="radio" checked={this.state.gender_karyawan === "Laki-laki"} onClick={(e) => this.setState({ gender_karyawan: e.target.value })} name="inlineRadioOptions" id="inlineRadio1" value="Laki-laki" />
                                                                    <label class="form-check-label" style={{ fontSize: "12px" }} for="inlineRadio1">Laki-Laki</label>
                                                                </div>
                                                                <div class="form-check form-check-inline">
                                                                    <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" onClick={(e) => this.setState({ gender_karyawan: e.target.value })} checked={this.state.gender_karyawan === "Perempuan"} value="Perempuan" />
                                                                    <label class="form-check-label" style={{ fontSize: "12px" }} for="inlineRadio2">Perempuan</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label style={{ fontSize: "12px", color: "#143B5E" }}className="mb-2 font-weight-bold">Tanggal Mulai Kerja Karyawan</label>
                                                    <div>
                                                        <input style={{ fontSize: "12px" }} name="join_date_karyawan" className="form-control" onChange={this.handleChange}
                                                               type="date" required="" />
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label style={{ fontSize: "12px", color: "#143B5E" }}className="mb-2 font-weight-bold">Divisi Karyawan</label>
                                                    <div>
                                                        <select style={{ fontSize: "12px" }} name="divisi_karyawan" className="form-control" onChange={this.handleChange}>
                                                            <option style={{ fontSize: "12px" }}>Pilih Divisi</option>
                                                            {divisi.map((item, index) => {
                                                                return (
                                                                    <option style={{ fontSize: "12px" }} value={item.divisi_id}>{item.divisi_name}</option>
                                                                )
                                                            })}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label style={{ fontSize: "12px", color: "#143B5E" }}className="mb-2 font-weight-bold">Jabatan Karyawan</label>
                                                    <div>
                                                        <select style={{ fontSize: "12px" }} name="jabatan_karyawan" className="form-control"
                                                            onChange={this.handleChange}>
                                                            <option style={{ fontSize: "12px" }}>Pilih Jabatan</option>
                                                            {jabatan.map((item, index) => {
                                                                return (
                                                                    <option style={{ fontSize: "12px" }} value={item.jabatan_id}>{item.jabatan_nama}</option>
                                                                )
                                                            })}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label style={{ fontSize: "12px", color: "#143B5E" }}className="mb-2 font-weight-bold">Lokasi Absen
                                                        Karyawan</label>
                                                    <div>
                                                        <label style={{ fontSize: "12px" }}>
                                                            <input style={{ fontSize: "12px" }} type="checkbox"
                                                                checked={this.state.lokasi_karyawan === null}
                                                                onChange={() => this.lokasiHandler()} />
                                                            &nbsp;Semua Lokasi Perusahaan
                                                        </label>
                                                        {this.state.lokasi_karyawan !== null &&
                                                            <Select name="lokasi_karyawan"
                                                                style={{ width: '100%' }}
                                                                mode={"multiple"}
                                                                placeholder="Pilih Lokasi"
                                                                filterOption={(input, option) =>
                                                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                    || option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                }
                                                                onChange={(event) => {
                                                                    this.setState({
                                                                        lokasi_karyawan: event
                                                                    })
                                                                }}>
                                                                {this.state.lokasi.map((item, index) => {
                                                                    return (<Option
                                                                        key={item.lokasi_id}>{item.lokasi_nama}</Option>)
                                                                })}
                                                            </Select>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    user: state.Auth.user,
    api_token: state.Auth.api_token,
    jabatan: state.Filter._jabatan,
    divisi: state.Filter._divisi
});

const mapDispatchToProps = dispatch => ({
    clear_auth: () => dispatch(clear_auth()),
    set_auth: (api_token, data) => dispatch(set_auth(api_token, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(Add_karyawan);
